import { Box } from '@chakra-ui/react'
import React from 'react'
import { useNavigate } from 'react-router'
import { useUserState } from '~/atoms/UserState'
import { AutoColorBadge } from '~/components/shared/AutoColorBadge'
import { useColorMode } from '~/components/ui/color-mode'
import { useChannelSwitcher } from '~/hooks/useChannelSwitcher'
import { isElectron } from '~/utils/common'

export const ChannelBadge = () => {
  const { currentChannel, availableChannels } = useChannelSwitcher()
  const navigate = useNavigate()
  const { colorMode } = useColorMode()

  // TODO: Only Internal Users can see the settings page, so we use this to prevent the click handler from being called for external users
  const { isInternalUser } = useUserState()

  if (
    !isElectron ||
    !currentChannel ||
    currentChannel === 'prod' ||
    currentChannel === 'dev'
  ) {
    return null
  }

  const channelInfo = availableChannels.find((c) => c.name === currentChannel)
  const displayName = channelInfo?.displayName || currentChannel

  const handleClick = () => {
    navigate('/settings/updates')
  }

  return (
    <Box
      position="relative"
      left="10px"
      cursor={isInternalUser ? 'pointer' : 'default'}
      onClick={isInternalUser ? handleClick : undefined}
    >
      <AutoColorBadge
        label={displayName}
        colorKey={currentChannel}
        theme={colorMode}
        fontSize="x-small"
        textTransform="lowercase"
      />
    </Box>
  )
}
